import { Offer } from '@wwt/entities/search-response'

import { assert } from '@/shared/lib/assert'

export const getRoomOfferPathToOfferId = (
	savedOfferId: Offer['IDs']['wwtOfferId']
) => {
	assert(
		savedOfferId !== undefined,
		'wwtOfferId is undefined on parse for create links to room offer page in offer card reservation'
	)

	const urlParamsForOffer = new URLSearchParams()
	urlParamsForOffer.set('wwtOfferId', String(savedOfferId))

	return {
		pathname: '/room-offer',
		search: urlParamsForOffer.toString()
	}
}
